export default "__VITE_ASSET__CxC2yUA8__"